// extracted by mini-css-extract-plugin
module.exports = {"hotelList":"Hotels_hotelList__3pSPY","searchText":"Hotels_searchText__2grZY"};